module.exports = __webpack_public_path__ + "static/img/sistema-hi-lo.2d26a9f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sistema-hi-lo.svg
// module id = pVvW
// module chunks = 1